import { useState } from "react";
import { toast } from "sonner";
import { Mail } from "lucide-react";
import { api } from "../lib/api";
import { trackEvent } from "../lib/track";

export function EmailCapture({ location = "footer", dark = false }) {
  const [email, setEmail] = useState("");
  const [consent, setConsent] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/subscribe", { email, consent, location });
      trackEvent("sign_up", { method: "email", location });
      toast.success(data.message);
      setEmail("");
      setConsent(false);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Something went wrong — please try again.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} className="w-full" data-testid={`email-capture-${location}`}>
      <div className="flex flex-col gap-3 sm:flex-row">
        <label className="sr-only" htmlFor={`email-${location}`}>Email address</label>
        <div className="relative flex-1">
          <Mail className="pointer-events-none absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 text-ink-muted" />
          <input
            id={`email-${location}`}
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Your email address"
            className="w-full rounded-full border border-sandline bg-white py-3.5 pl-11 pr-4 text-sm text-ink placeholder:text-ink-muted"
            data-testid={`email-input-${location}`}
          />
        </div>
        <button type="submit" disabled={busy} className="btn-primary disabled:opacity-60" data-testid={`email-submit-${location}`}>
          {busy ? "Joining…" : "Be first to hear"}
        </button>
      </div>
      <label className="mt-3 flex items-start gap-2.5 text-xs leading-relaxed text-ink-muted" data-testid={`email-consent-${location}`}>
        <input
          type="checkbox"
          checked={consent}
          onChange={(e) => setConsent(e.target.checked)}
          className="mt-0.5 h-4 w-4 rounded border-sandline accent-[#1A362D]"
          data-testid={`email-consent-checkbox-${location}`}
        />
        <span>
          Yes, email me new Perfect Breaks and offers. I can unsubscribe anytime. See our{" "}
          <a href="/privacy" className="underline">privacy notice</a>.
        </span>
      </label>
    </form>
  );
}
